import { render, staticRenderFns } from "./EventsCalendarView.vue?vue&type=template&id=715a8578&scoped=true&"
import script from "./EventsCalendarView.vue?vue&type=script&lang=ts&"
export * from "./EventsCalendarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a8578",
  null
  
)

export default component.exports